import { useTranslation } from 'react-i18next';

import { useRegisterActionsMobileMenuContainer } from './actionsMobileMenu';
import { MobileMenuButtonItem } from './MobileMenuButtonItem';

export type MobileMenuMoreSubmenuProps = {
  incidentIsClosed: boolean;
};

export function MobileMenuMoreSubmenu(props: MobileMenuMoreSubmenuProps) {
  void props;
  const { t } = useTranslation();
  const registerContainer = useRegisterActionsMobileMenuContainer();

  return (
    <div className="mobile-menu-more-submenu btn-group dropup">
      <MobileMenuButtonItem
        icon="fa-light fa-ellipsis"
        title={t('Incident_MobileLayout_TabButton_More')}
        isDropdown
        testID="incident-more-button"
      />

      <ul className="dropdown-menu" style={{ width: '100vw' }} ref={registerContainer}>
      </ul>
    </div>
  );
}
